module.exports = __webpack_public_path__ + "img/mapnew_small.13f64ca7.png";